export default __webpack_public_path__ + "static/media/026-obelisk of buenos aires.0f0dfb2d.svg";